module.exports = require("npm:querystring@0.2.0/index");